import { Card, CardContent } from "@/components/shadcn/card"
import { cn } from "@/lib/utils"

interface PageCardProps {
  children?: React.ReactNode
  className?: string
}

export function PageCard({ children, className }: PageCardProps) {
  return (
    <Card className="flex flex-col flex-1">
      <CardContent className={cn("flex flex-col flex-1", className)}>
        {children}
      </CardContent>
    </Card>
  )
}
